{
  "name": "oskaru-net",
  "version": "1.3.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build:ci": "ng build --source-map=true && npm run sentry:sourcemaps",
    "test:ci": "ng test --watch=false --code-coverage --source-map true --browsers=ChromeHeadless",
    "test:dev": "ng test --watch=true --code-coverage --source-map true --browsers=ChromeHeadless",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org oskarunet --project oskaru-angular-frontend ./dist && sentry-cli sourcemaps upload --org oskarunet --project oskaru-angular-frontend ./dist"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^19.2.13",
    "@angular/common": "^19.2.11",
    "@angular/compiler": "^19.2.11",
    "@angular/core": "^19.2.11",
    "@angular/forms": "^19.2.14",
    "@angular/platform-browser": "^19.2.11",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/router": "^19.2.14",
    "@angular/service-worker": "^19.2.14",
    "@primeng/themes": "^19.1.3",
    "@sentry/angular": "^9.27.0",
    "@sentry/browser": "^9.25.1",
    "@sentry/cli": "^2.46.0",
    "@tailwindcss/postcss": "^4.1.8",
    "ag-grid-angular": "^33.3.2",
    "chart.js": "^4.4.9",
    "chartjs-adapter-date-fns": "^3.0.0",
    "crypto-es": "^2.1.0",
    "lineicons": "^1.3.2",
    "ng2-charts": "^8.0.0",
    "ngx-device-detector": "^9.0.0",
    "ngx-indexed-db": "^20.0.1",
    "postcss": "^8.5.4",
    "primeicons": "^7.0.0",
    "primeng": "^19.1.3",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.1.10",
    "tailwindcss-primeui": "^0.6.1",
    "tslib": "^2.3.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.14",
    "@angular/cli": "^19.2.14",
    "@angular/compiler-cli": "^19.2.14",
    "@types/crypto-js": "^4.2.2",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.7.2"
  }
}
